import { TextField } from "@mui/material";
import axios from "axios";
import styles from "./LoginForm.module.css";
import { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Link } from "react-router-dom";
import { StorageSetItem } from "../../../admin/components/StorageComp";

export default function LoginForm({ onSubmit, isFP, setLoading }) {
  const [errorMsg, setErrorMsg] = useState("");

  const { register, handleSubmit, control, formState: { errors } } = useForm({
    mode: "onChange",
  });

  async function onSubmitLocal(data) {
    setLoading(true);
    setErrorMsg("");

    return axios.post(process.env.REACT_APP_API_URL + "v1/login", data).then((response) => {
      setLoading(false);
      if (response.data.status === "SUCCESS") {
        const resData = response.data.data;
        StorageSetItem("bookAuthData", JSON.stringify(resData), 24 * 60 * 60 * 1000);
        onSubmit();
      }
      if (response.data.status === "ERROR") {
        setErrorMsg(response?.data?.message);
      }
    }).catch((error) => {
      if (error && error?.response && error?.response?.data && error?.response?.data?.message) {
        setErrorMsg(error?.response?.data?.message);
      }
      setLoading(false);
    });
  }

  return (<>
    <form onSubmit={handleSubmit(onSubmitLocal)}>
      <p className={`${styles.ErrorM}`}>{errorMsg}</p>
      <div className={`${styles.FormRow}`}>
        <div className={`${styles.FormGroup} FormGroup`}>
          <Controller
            control={control}
            {...register("email", {
              required: "This field is Required",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "Invalid email address",
              },
            })}
            render={({ field }) => (<TextField {...field} label="Email*" variant="outlined" />)}
          />
          {errors.email && (<span className={`${styles.ErrorM}`}>{errors.email.message}</span>)}
        </div>
        <div className={`${styles.FormGroup} FormGroup`}>
          <Controller
            {...register("password", { required: "This field is Required" })}
            control={control}
            render={({ field }) => (<TextField {...field} label="Password*" variant="outlined" type="password" />)}
          />
          {errors.password && (<span className={`${styles.ErrorM}`}>{errors.password.message}</span>)}
        </div>
        {isFP && (<Link to={"/forgot-password"} className={`${styles.ForhotPassText}`}>Forgot Password</Link>)}
      </div>

      <button type="submit" className={`${styles.LoginBU}`}>
        <span>Login</span>
      </button>
      <p className={`${styles.LoginFormSText}`}><Link to={"/sign-up"} className={`${styles.ForhotPassText}`}>Create a new free account</Link></p>
    </form>
  </>);
}